module.exports = __webpack_public_path__ + "assets/img/xnlb_03.e9646cc7.jpg";